import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, catchError, filter } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-document-view-logo',
  templateUrl: './document-view-logo.component.html',
  styleUrls: ['./document-view-logo.component.css']
})
export class DocumentViewLogoComponent implements OnInit {
  @Input() organizationId: string;
  environment = environment;
  image: Observable<any>;

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    const url = environment.apiUrl + '/v1/organizations/' + this.organizationId + '/images/logo';            

    this.image = this.http.get(url, { responseType: 'blob' })
      .pipe(
        catchError(() => of(null)),
        filter(blog => !!blog),
        map(blob => {
          const imageUrl = URL.createObjectURL(blob);
          return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
        }),
      );
  }
}
